import React from "react";
import { formatShowDisplayTime } from "./datetime/LightweightDateTimeUtils";

export function createGuests(prefix, guests) {
    if (!guests || guests.length === 0) {
        return null;
    }

    const guestsEls = guests.map((guest, index) => {
        const name = guest.guestName;
        if (!name) {
            return null;
        }

        const startTime = guest.guestStartTime
            ? formatShowDisplayTime(new Date(guest.guestStartTime))
            : "";
        const company = guest.guestCompanyName || "";
        const title = guest.guestTitle || "";
        const guestWorkDetails = company
            ? company + (title ? ", " + title : "")
            : "";

        return (
            <li key={`guest-${index}`} className={`${prefix}__guest`}>
                <div className={`${prefix}__guest-start-time`}>{startTime}</div>
                <div className={`${prefix}__guest-name`}>{name}</div>
                <div className={`${prefix}__guest-work-details`}>
                    {guestWorkDetails}
                </div>
            </li>
        );
    });

    return <ul className={`${prefix}__guests`}>{guestsEls}</ul>;
}

export function createUpNext(prefix, index, localizer) {
    if (index !== 1) {
        return null;
    }

    return <div className={`${prefix}__item-next`}>{localizer("UP_NEXT")}</div>;
}

export function createShowTime(prefix, startTime) {
    const showStartTime = new Date(startTime);
    return (
        <time
            className={`${prefix}__show-time`}
            dateTime={showStartTime.toJSON()}
        >
            {formatShowDisplayTime(showStartTime)}
        </time>
    );
}

export function createShowName(Tag, prefix, localizer, showTitle) {
    return <Tag className={`${prefix}__show-name`}>{localizer(showTitle)}</Tag>;
}
